import React, { useState } from "react";
import { motion } from "framer-motion";
import styles from "./mythMachine.module.css";
import ImagePlayer from "../../../components/imagePlayer/ImagePlayer";
import ControlUnit, {
  totalBands,
} from "../../../components/controlUnit/ControlUnit";
import ConnectorRods from "../../../components/connectorRods/ConnectorRods";
import TimeDisplay from "../../../components/timeDisplay/TimeDisplay";
import ReelToReel from "../../../components/reelToReel/ReelToReel";
import { WaveformPlayer } from "../../../components/waveformPlayer/WaveformPlayer";

const IN_TEST_MODE = false;

const thingsToAnimate = 4;
const animationEnd = 0.2;
const fractionPerThing = animationEnd / thingsToAnimate;
const tapePlayerTimings = {
  start: 0,
  end: fractionPerThing,
  duration: fractionPerThing - 0,
};

export default function MythMachine({
  currMyth,
  comicCanvas,
  placeCanvas,
  viewType,
}) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currSeconds, setCurrSeconds] = useState(0);
  const [totalSeconds, setTotalSeconds] = useState(0);
  const [fakeProgress, setFakeProgress] = useState(0.5);
  const [ampVals, setAmpVals] = useState([...Array(totalBands).fill(0)]);

  let progress = currSeconds / totalSeconds;
  isNaN(progress) ? (progress = 0) : (progress = progress.toFixed(4));

  const onProgressSliderChange = (newValue) => {
    IN_TEST_MODE ? setFakeProgress(newValue) : setCurrSeconds(newValue);
  };

  return (
    <motion.div
      className={styles.outer}
      exit={{ opacity: 0, transition: { duration: 0.3 } }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1.3 } }}
    >
      <div className={styles.machineStack}>
        <div className={styles.stack1}>
          <div className={styles.imagePlayerHolder}>
            <ImagePlayer
              comicCanvas={comicCanvas}
              placeCanvas={placeCanvas}
              progress={IN_TEST_MODE ? fakeProgress : progress}
            />
          </div>

          {viewType !== "desktop" && (
            <div className={styles.mobileOnlyTimeDisplay}>
              <ConnectorRods />

              <div className={styles.testDiv}>
                <div className={styles.testDivContent}>
                  <WaveformPlayer
                    duration={totalSeconds}
                    placeCanvas={placeCanvas}
                    currTime={currSeconds}
                    waveformData={currMyth.audio.waveformData}
                    onClick={(s) => setCurrSeconds(s)}
                  />
                </div>
              </div>
            </div>
          )}

          {viewType !== "mobileLandscape" && (
            <div className={styles.hideOnMobleLandscape}>
              <ConnectorRods />

              <ControlUnit
                audioSource={currMyth.audio.url}
                currSeconds={currSeconds}
                setCurrSeconds={setCurrSeconds}
                totalSeconds={totalSeconds}
                setTotalSeconds={setTotalSeconds}
                progress={IN_TEST_MODE ? fakeProgress : progress}
                onProgressUpdate={onProgressSliderChange}
                isPlaying={isPlaying}
                setIsPlaying={setIsPlaying}
                setAmpVals={setAmpVals}
              />
            </div>
          )}
        </div>

        <div className={styles.stack2}>
          {viewType !== "mobileLandscape" && (
            <div className={styles.hideOnMobleLandscape}>
              <ReelToReel
                totalSeconds={totalSeconds}
                progress={progress}
                timings={tapePlayerTimings}
                ampVals={ampVals}
              />

              <ConnectorRods />
            </div>
          )}

          <WaveformPlayer
            placeCanvas={placeCanvas}
            duration={totalSeconds}
            currTime={currSeconds}
            waveformData={currMyth.audio.waveformData}
            onClick={(s) => setCurrSeconds(s)}
          />

          <ConnectorRods double={false} />

          {viewType !== "mobileLandscape" && (
            <div className={styles.hideOnMobleLandscape}>
              <TimeDisplay currSeconds={currSeconds} ampVals={ampVals} />
            </div>
          )}

          {viewType === "mobileLandscape" && (
            <div className={styles.showOnMobleLandscape}>
              <ControlUnit
                audioSource={currMyth.audio.url}
                currSeconds={currSeconds}
                setCurrSeconds={setCurrSeconds}
                totalSeconds={totalSeconds}
                setTotalSeconds={setTotalSeconds}
                progress={IN_TEST_MODE ? fakeProgress : progress}
                onProgressUpdate={onProgressSliderChange}
                isPlaying={isPlaying}
                setIsPlaying={setIsPlaying}
                setAmpVals={setAmpVals}
              />
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
}
